import { render, staticRenderFns } from "./numbersShow.vue?vue&type=template&id=19342078&scoped=true"
import script from "./numbersShow.vue?vue&type=script&lang=js"
export * from "./numbersShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19342078",
  null
  
)

export default component.exports